
import Cookies from 'vue-cookies'
// actions
export const LOAD = 'LOAD'
export const SET = 'SET'
export const CLEAR = 'CLEAR'
// mutations
export const UPDATE = 'UPDATE'
export const ADD_ITEM = 'ADD_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const ITEM_AMOUNT_PLUS = 'ITEM_AMOUNT_PLUS'
export const ITEM_AMOUNT_MINUS = 'ITEM_AMOUNT_MINUS'
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD'
export const UPDATE_TYPE = 'UPDATE_TYPE'
export const UPDATE_TABLE_NO = 'UPDATE_TABLE_NO'
export const UPDATE_CART_NOTE = 'UPDATE_CART_NOTE'
export const UPDATE_CART_RESERVATION = 'UPDATE_CART_RESERVATION'
export const UPDATE_REDEEMCOIN = 'UPDATE_REDEEMCOIN'
export const UPDATE_CONSUMER_OFFER_IDS = 'UPDATE_CONSUMER_OFFER_IDS'

// getters
export const ORDER_DATA = 'ORDER_DATA'
export const STORE_ID = 'STORE_ID'
export const CART_ITEMS = 'CART_ITEMS'
export const CART_ITEM_COUNT = 'CART_ITEM_COUNT'
export const CART_PRICE = 'CART_PRICE'
export const CART_STORE = 'CART_STORE'
export const PAYMENT_METHOD = 'PAYMENT_METHOD'
export const CART_TYPE = 'CART_TYPE'
export const CART_TABLE_NO = 'CART_TABLE_NO'
export const CART_NOTE = 'CART_NOTE'
export const CART_RESERVATION = 'CART_RESERVATION'
export const CONSUMER_OFFER_IDS = 'CONSUMER_OFFER_IDS'

const state = {
  items: [],
  menuId: null,
  note: '',
  paymentMethod: 'Cash',
  price: 0,
  redeemCoin: 0,
  reservation: {
    mobile: '',
    time: '',
    name: ''
  },
  ConsumerOfferIds: [],
  store: {
    id: null,
    name: ''
  },
  tableNo: '',
  type: 'dineIn'
}
const methods = {
  computePrice () {
    let _price = 0
    for (let item in state.items) {
      _price += state.items[item].price
    }
    return _price
  },
  getCookie () {
    let _cart = Cookies.get('cart')
    return _cart
  },
  setCookie (data) {
    Cookies.set('cart', JSON.stringify(state))
  },
  clearCookie () {
    Cookies.remove('cart')
  }
}
const actions = {
  [LOAD] ({ commit }) {
    let _cart = methods.getCookie()
    if (_cart) {
      commit(UPDATE, _cart)
    }
  },
  [SET] ({ commit }, data) {
    commit(UPDATE, data)
    methods.setCookie(state)
  },
  [CLEAR] ({ commit }) {
    commit(UPDATE, {
      store: {
        id: null,
        name: ''
      },
      menuId: null,
      items: [],
      note: '',
      price: 0,
      type: 'dineIn',
      paymentMethod: 'Cash',
      tableNo: ''
    })
    methods.clearCookie()
  }
}
const mutations = {
  [UPDATE] (state, data) {
    state.store = data.store
    state.menuId = data.menuId
    state.note = data.note
    state.price = data.price
    state.type = data.type
    state.paymentMethod = data.paymentMethod
    state.tableNo = data.tableNo
    state.items = data.items
  },
  [ADD_ITEM] (state, item) {
    if (item) {
      if (!state.items) {
        state.items = []
      }
      state.items.push(item)
      state.price = methods.computePrice()
      methods.setCookie(state)
    }
  },
  [REMOVE_ITEM] (state, index) {
    if (index >= 0) {
      state.items.splice(index, 1)
      state.price = methods.computePrice()
      methods.setCookie(state)
    }
  },
  [ITEM_AMOUNT_PLUS] (state, index) {
    if (index >= 0) {
      let _item = state.items[index]
      if (_item.amount) {
        _item.price = (_item.originPrice + (_item.custPrice || 0)) * ++_item.amount
        state.price = methods.computePrice()
        methods.setCookie(state)
      }
    }
  },
  [ITEM_AMOUNT_MINUS] (state, index) {
    if (index >= 0) {
      let _item = state.items[index]
      if (_item.amount > 1) {
        _item.price = (_item.originPrice + (_item.custPrice || 0)) * --_item.amount
      } else {
        state.items.splice(index, 1)
      }
      state.price = methods.computePrice()
      methods.setCookie(state)
    }
  },
  [UPDATE_TABLE_NO] (state, data) {
    state.tableNo = data
    methods.setCookie(state)
  },
  [UPDATE_PAYMENT_METHOD] (state, data) {
    state.paymentMethod = data
    methods.setCookie(state)
  },
  [UPDATE_TYPE] (state, data) {
    state.type = data
    methods.setCookie(state)
  },
  [UPDATE_CART_NOTE] (state, data) {
    state.note = data
    methods.setCookie(state)
  },
  [UPDATE_REDEEMCOIN] (state, data) {
    state.redeemCoin = data
  },
  [UPDATE_CART_RESERVATION] (state, data) {
    state.reservation = data
  },
  [UPDATE_CONSUMER_OFFER_IDS] (state, data) {
    state.ConsumerOfferIds = data
  }
}

const getters = {
  [ORDER_DATA] (state) {
    return {
      menuId: state.menuId,
      note: state.note || '',
      tableNo: state.tableNo || '',
      type: state.type,
      paymentMethod: state.paymentMethod,
      redeemCoin: state.redeemCoin,
      reservation: {
        name: state.reservation.name || undefined,
        mobile: state.reservation.mobile || undefined,
        time: state.reservation.time || undefined
      },
      ConsumerOfferIds: state.ConsumerOfferIds,
      Details: state.items.map(function (item) {
        return {
          productId: item.id,
          productStyleId: item.productStyleId,
          amount: item.amount,
          note: item.note,
          cust: item.cust
        }
      })
    }
  },
  [STORE_ID] (state) {
    return state.store.id
  },
  [CART_ITEMS] (state) {
    return state.items
  },
  [CART_ITEM_COUNT] (state) {
    return state.items.length
  },
  [CART_PRICE] (state) {
    return state.price
  },
  [PAYMENT_METHOD] (state) {
    return state.paymentMethod
  },
  [CART_STORE] (state) {
    return state.store
  },
  [CART_TYPE] (state) {
    return state.type
  },
  [CART_TABLE_NO] (state) {
    return state.tableNo
  },
  [CART_NOTE] (state) {
    return state.note
  },
  [CART_RESERVATION] (state) {
    return state.reservation
  },
  [CONSUMER_OFFER_IDS] (state) {
    return state.ConsumerOfferIds
  }
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true // 多模組的時候，當有相同名稱的變數或方法才能區隔開
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js